"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentResourceFunctionConsumptionSchema = exports.IComponentResourceInstanceSchema = exports.IComponentResourceSchema = void 0;
const IModeCondition_1 = require("../DesignModels/IModeCondition");
const metadata_1 = require("../DesignModels/metadata");
const zod_1 = require("zod");
exports.IComponentResourceSchema = zod_1.z.object({
    name: zod_1.z.string(),
    conditions: zod_1.z.lazy(() => IModeCondition_1.IModeConditionSchema.array().optional()),
    mustBeConsumed: zod_1.z.boolean().optional(),
    metadata: metadata_1.MetadataSchema.optional(),
});
exports.IComponentResourceInstanceSchema = exports.IComponentResourceSchema.extend({
    id: zod_1.z.string(),
    componentName: zod_1.z.string(),
    moduleName: zod_1.z.string(),
});
exports.ComponentResourceFunctionConsumptionSchema = zod_1.z.object({
    resource: zod_1.z.string(),
    function: zod_1.z.string(),
});
//# sourceMappingURL=IComponentResource.js.map